import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';

const InputError = styled(Typography)(`
  color: #FE7877;
`);

export default InputError;
